const LOCAL_STORAGE_WISHLIST_KEY = 'shopify_wishlist';

class Wishlist {
  constructor() {
    console.log('Wishlist JS initialized');
    try {
      this.initButtons();
    } catch (e) {
      console.error('Error in initButtons:', e);
    }
    
    try {
      this.initWishlistPage();
    } catch (e) {
      console.error('Error in initWishlistPage:', e);
      this.showError(e.message);
    }
  }

  showError(msg) {
    const grid = document.querySelector('#WishlistGrid');
    if (grid) {
      grid.innerHTML = `<div style="text-align:center; padding: 50px; color: red;"><h3>Debug Error:</h3><p>${msg}</p></div>`;
    }
  }

  getWishlist() {
    try {
      const wishlist = localStorage.getItem(LOCAL_STORAGE_WISHLIST_KEY);
      const parsed = wishlist ? JSON.parse(wishlist) : [];
      return Array.isArray(parsed) ? parsed : [];
    } catch (e) {
      console.error('Error parsing wishlist from localStorage', e);
      return [];
    }
  }

  setWishlist(wishlist) {
    try {
      localStorage.setItem(LOCAL_STORAGE_WISHLIST_KEY, JSON.stringify(wishlist));
    } catch (e) {
      console.error('Error saving wishlist', e);
    }
  }

  updateButtons() {
    const wishlist = this.getWishlist();
    document.querySelectorAll('.product-card__wishlist-btn').forEach((btn) => {
      const handle = btn.getAttribute('data-product-handle');
      if (wishlist.includes(handle)) {
        btn.classList.add('is-active');
      } else {
        btn.classList.remove('is-active');
      }
    });
  }

  initButtons() {
    this.updateButtons();
    
    document.addEventListener('click', (e) => {
      const btn = e.target.closest('.product-card__wishlist-btn');
      if (!btn) return;

      e.preventDefault();
      e.stopPropagation();

      const handle = btn.getAttribute('data-product-handle');
      if (!handle) return;

      let wishlist = this.getWishlist();
      if (wishlist.includes(handle)) {
        wishlist = wishlist.filter((item) => item !== handle);
      } else {
        wishlist.push(handle);
      }

      this.setWishlist(wishlist);
      this.updateButtons();

      if (document.querySelector('#WishlistGrid')) {
        const productCard = btn.closest('.product-grid__item') || btn.closest('.wishlist-card') || btn.closest('.resource-list__item');
        if (productCard) {
          productCard.style.display = 'none';
        }
      }
    });
  }

  async initWishlistPage() {
    let grid = document.querySelector('#WishlistGrid');
    
    if (!grid && window.location.pathname.toLowerCase().includes('wishlist')) {
      console.log('WishlistGrid not found! Creating a fallback grid.');
      
      // Hide the default page title if it exists
      const defaultTitle = document.querySelector('.main-page-title');
      if (defaultTitle) defaultTitle.style.display = 'none';

      // Create a wrapper that matches the collection layout
      const wrapper = document.createElement('div');
      wrapper.className = 'wishlist-wrapper page-width';
      
      // Inject responsive styling and the header
      wrapper.innerHTML = `
        <style>
          .wishlist-wrapper {
            padding: 48px 20px 60px 20px;
            max-width: var(--page-width, 1400px);
            margin: 0 auto;
          }
          @media screen and (min-width: 750px) {
            .wishlist-wrapper {
              padding-left: 50px;
              padding-right: 50px;
            }
          }
          .wishlist-results-grid {
            display: grid;
            grid-template-columns: repeat(2, 1fr);
            gap: 16px !important;
            list-style: none;
            padding: 0;
            margin: 0;
            width: 100%;
          }
          @media screen and (min-width: 750px) {
            .wishlist-results-grid {
              grid-template-columns: repeat(4, 1fr);
              gap: 40px !important;
            }
          }
        </style>
        <div id="WishlistInjectedTitle" style="margin-bottom: 60px;">
          <h1 style="margin: 0; font-family: var(--font-h2--family); font-style: var(--font-h2--style); font-weight: var(--font-h2--weight); font-size: var(--font-h2--size); line-height: var(--font-h2--line-height); text-align: left;">Wishlist</h1>
        </div>
        <div id="WishlistGrid"></div>
      `;
      
      const mainContent = document.querySelector('#MainContent') || document.body;
      mainContent.appendChild(wrapper);
      grid = document.querySelector('#WishlistGrid');
    }

    if (!grid) {
      return;
    }

    const wishlist = this.getWishlist();

    const hideWishlistTitles = () => {
      // Hide the injected fallback title
      const injectedTitle = document.querySelector('#WishlistInjectedTitle');
      if (injectedTitle) injectedTitle.style.display = 'none';
      
      // Hide theme default page titles that say "Wishlist"
      document.querySelectorAll('h1').forEach(h1 => {
        if (h1.textContent.trim().toLowerCase().includes('wishlist')) {
          h1.style.display = 'none';
          // If it has a specific wrapper, hide that too
          if (h1.closest('.wishlist-page-header')) h1.closest('.wishlist-page-header').style.display = 'none';
        }
      });
    };

    if (wishlist.length === 0) {
      hideWishlistTitles();
      grid.innerHTML = '<div class="wishlist-empty" style="text-align: center; padding: 60px 0;"><p>Your wishlist is empty.</p><a href="/collections/all" class="button button--primary" style="display:inline-block; padding: 14px 32px; background: #000; color: #fff; text-decoration: none; border-radius: 50px; font-weight: 600;">Continue Shopping</a></div>';
      return;
    }

    // Show loading state
    grid.innerHTML = '<div class="wishlist-loader"><svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg"><circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle></svg></div>';

    try {
      const productPromises = wishlist.map(async handle => {
        try {
          const res = await fetch(`/products/${handle}.js`);
          if (!res.ok) return null;
          return await res.json();
        } catch (e) {
          return null;
        }
      });

      const products = await Promise.all(productPromises);
      const validProducts = products.filter(p => p !== null);

      if (validProducts.length === 0) {
        hideWishlistTitles();
        grid.innerHTML = '<div class="wishlist-empty" style="text-align: center; padding: 60px 0;"><p>Your wishlist products are no longer available.</p><a href="/collections/all" class="button button--primary" style="display:inline-block; padding: 14px 32px; background: #000; color: #fff; text-decoration: none; border-radius: 50px; font-weight: 600;">Continue Shopping</a></div>';
        return;
      }

      // We use the injected explicit CSS classes to guarantee 4-column layout on desktop
      let html = '<ul class="wishlist-results-grid product-grid product-grid--grid">';
      
      validProducts.forEach((product, index) => {
        const isMobile = window.innerWidth < 750;
        let discountHtml = '';
        if (product.compare_at_price > product.price) {
          const discountPct = Math.round(((product.compare_at_price - product.price) / product.compare_at_price) * 100);
          if (discountPct > 0) {
            discountHtml = `
              <div style="position: absolute; top: ${isMobile ? '8px' : '12px'}; left: ${isMobile ? '8px' : '12px'}; z-index: 2; display: flex; flex-direction: column; align-items: flex-start; gap: ${isMobile ? '4px' : '6px'}; pointer-events: none;">
                <div style="background: #e8312a; color: #fff; padding: ${isMobile ? '4px 9px' : '7px 13px'}; border-radius: 50px; font-size: ${isMobile ? '10px' : '13px'}; font-weight: 600; box-shadow: 0 2px 8px rgba(0,0,0,0.25);">
                  -${discountPct}% Off
                </div>
                <div style="background: #ffffff; color: #111827; padding: ${isMobile ? '3px 8px' : '5px 12px'}; border-radius: 50px; font-size: ${isMobile ? '9.5px' : '11px'}; font-weight: 700; text-transform: uppercase; letter-spacing: 0.5px; box-shadow: 0 2px 6px rgba(0,0,0,0.12); border: 1px solid rgba(0,0,0,0.08);">
                  Sale
                </div>
              </div>
            `;
          }
        }

        const priceFormatted = 'Rs. ' + (product.price / 100).toFixed(2);
        
        let imageUrl = product.featured_image || '';
        if (imageUrl.startsWith('//')) imageUrl = 'https:' + imageUrl;
        // Optimization: request 600px width image from Shopify CDN
        imageUrl = imageUrl.replace(/(\.[a-zA-Z0-9]+)(\?.*)?$/, '_600x$1$2');

        html += `
          <li class="product-grid__item product-grid__item--${index}" style="border: none;">
            <div class="product-card__content" style="border-radius: 24px; padding-bottom: 20px; display: flex; flex-direction: column; gap: 4px; position: relative; background: transparent;">
              
              ${discountHtml}

              <button class="product-card__wishlist-btn is-active" data-product-handle="${product.handle}" style="position: absolute; top: ${isMobile ? '8px' : '12px'}; right: ${isMobile ? '8px' : '12px'}; z-index: 2; width: ${isMobile ? '32px' : '44px'}; height: ${isMobile ? '32px' : '44px'}; border-radius: 50%; background: #fff; display: flex; align-items: center; justify-content: center; box-shadow: 0 4px 12px rgba(0,0,0,0.1); border: none; cursor: pointer; color: #000; opacity: 1;">
                <svg xmlns="http://www.w3.org/2000/svg" width="${isMobile ? '14' : '20'}" height="${isMobile ? '14' : '20'}" viewBox="0 0 24 24" fill="currentColor" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path>
                </svg>
              </button>

              <a href="${product.url}" style="display: block; width: 100%; border-radius: 24px; overflow: hidden; line-height: 0;">
                <div style="aspect-ratio: 1/1; width: 100%;">
                  <img src="${imageUrl}" alt="${product.title}" style="width: 100%; height: 100%; object-fit: cover;" loading="lazy">
                </div>
              </a>

              <div style="text-align: center; padding-top: 16px; padding-left: 10px; padding-right: 10px;">
                <a href="${product.url}" style="text-decoration: none; color: inherit;">
                  <p style="margin: 0; font-family: var(--font-body--family); font-size: 1rem; font-weight: 500; color: var(--color-foreground); line-height: 1.4;">${product.title}</p>
                </a>
                <p style="margin: 2px 0 0 0; font-family: var(--font-body--family); font-size: 1rem; color: #555;">${priceFormatted}</p>
              </div>

            </div>
          </li>
        `;
      });

      html += '</ul>';
      grid.innerHTML = html;
      this.updateButtons();
    } catch (error) {
      console.error('Critical error rendering wishlist:', error);
      this.showError(error.toString());
    }
  }
}

const initWishlist = () => {
  if (window.wishlistInitialized) return;
  window.wishlistInitialized = true;
  new Wishlist();
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initWishlist);
} else {
  initWishlist();
}
